import { ImagesData } from '@/interface/top-up-active';

// 奖品类型下拉选项
export const typeOptions = [
  {
    value: 1,
    label: '云币',
  },
  {
    value: 2,
    label: '周期卡',
  },
  {
    value: 3,
    label: '现金券',
  },
  {
    value: 4,
    label: '第三方码',
  },
  {
    value: 5,
    label: '云朵',
  },
];

export const imageDescModel = {
  pageBG: {
    pc: {
      isFixed: true,
      width: 400,
      height: 560,
      size: 1024 * 1024 * 10,
    },
    web: {
      isFixed: true,
      width: 750,
      height: 1334,
      size: 1024 * 1024 * 10,
    },
  },
  pageBtn: {
    pc: {
      isFixed: true,
      width: 210,
      height: 50,
      size: 1024 * 1024 * 10,
    },
    web: {
      isFixed: true,
      width: 630,
      height: 100,
      size: 1024 * 1024 * 10,
    },
  },
  pageDisabledBtn: {
    pc: {
      isFixed: true,
      width: 210,
      height: 50,
      size: 1024 * 1024 * 10,
    },
    web: {
      isFixed: true,
      width: 630,
      height: 100,
      size: 1024 * 1024 * 10,
    },
  },
};

/**
 * 正整数校验
 * @param _
 * @param value
 * @param callback
 */
const natureNumber = (_: any, value: number = 0, callback: Function) => {
  if (isNaN(value)) {
    callback(new Error('请输入数字'));
  } else if (value < 0) {
    callback(new Error('请输入大于0的整数'));
  } else if (parseInt(value.toString() || '0') != parseFloat(value.toString() || '0')) {
    callback(new Error('请输入整数'));
  } else {
    callback();
  }
};

/**
 * 大于0的小数校验
 * @param num 保留小数位数
 * @param value
 * @param callback
 */
const floatNumber = (num: number = 2) => (_: any, value: number = 0, callback: Function) => {
  if (isNaN(value)) {
    callback(new Error('请输入数字'));
  } else if (value < 0) {
    callback(new Error('请输入大于0的整数'));
  } else if (value.toString().split('.')[1] && value.toString().split('.')[1].length > num) {
    callback(new Error(`小数点后保留${num}位`));
  } else {
    callback();
  }
};

/**
 * 中奖概率校验
 * @param value
 * @param callback
 */
const precentNumber = (_: any, value: number = 0, callback: Function) => {
  if (value > 100) {
    callback(new Error('中奖概率不能大于100%'));
  } else {
    callback();
  }
};

/**
 * 图片校验
 * @param value
 * @param callback
 */
const imageRule = (_: any, value: ImagesData, callback: Function) => {
  if (!value.imageUrl) {
    callback(new Error('请上传图片'));
  } else {
    callback();
  }
};

/**
 * 表单校验规则
 */
export const rules = {
  name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
  kind: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
  part_in: [{ validator: natureNumber, trigger: 'change' }],
  prizes: [{ required: true, message: '请配置奖品', trigger: 'blur' }],
  prizesType: [{ required: true, message: '请选择奖品类型', trigger: 'change' }],
  prizesName: [{ required: true, message: '请输入奖品名称', trigger: 'change' }],
  prizesPackID: [{ required: true, message: '请输入推广码批次号', trigger: 'change' }],
  prizesAmount: [{ validator: natureNumber, trigger: 'change' }],
  prizesOdds: [
    { required: true, message: '请输入中奖概率', trigger: 'blur' },
    { validator: floatNumber(1), trigger: 'change' },
    { validator: floatNumber(1), trigger: 'blur' },
    { validator: precentNumber, trigger: 'change' },
  ],

  gradeType: [{ required: true, message: '请选择充值档位', trigger: 'change' }],
  coinGrade: [{ required: true, message: '请选择充值档位', trigger: 'change' }],
  cardGrade: [{ required: true, message: '请选择充值档位', trigger: 'change' }],
  spGoods: [{ required: true, message: '请选择绑定商品', trigger: 'change' }],
  yun_grade: [{ required: true, message: '请选择云朵商品', trigger: 'change' }],
  intro: [{ required: true, message: '', trigger: 'blur' }],
  intro01: [{ required: true, message: '请输入说明文字', trigger: 'blur' }],
  intro02: [{ required: true, message: '请输入说明文字', trigger: 'blur' }],
  intro03: [{ required: true, message: '请输入支付说明', trigger: 'blur' }],
  pageBG: [{ required: true, message: '', trigger: 'blur' }],
  pageBtn: [{ required: true, message: '', trigger: 'blur' }],
  pageDisabledBtn: [{ required: true, message: '', trigger: 'blur' }],
  activeTime: [{ required: true, message: '请选择活动时间', trigger: 'blur' }],
  images: [
    { required: true, message: '请上传图片', trigger: 'blur' },
    { validator: imageRule, trigger: 'blur' },
  ],
};
